<div class="table__row" role="row" [formGroup]="item">
    <span class="table__cell table__cell--align-left table__cell--half" role="cell">
        <input type="checkbox"
               class="checkbox__input"
               aria-label="Select school"
               title="Select school"
               formControlName="isSelected" />
    </span>
    <span class="table__cell table__cell--align-left table__cell--half" role="cell">{{ schoolItm.id }}</span>
    <span class="table__cell table__cell--align-left table__cell--one-half" role="cell">{{ schoolItm.longName }}</span>
    <span class="table__cell table__cell--align-left" role="cell">{{ schoolItm.levelName }}</span>
    <span class="table__cell table__cell--align-left" role="cell">{{ schoolItm.districtId }}</span>
    <span class="table__cell table__cell--align-left" role="cell">{{ schoolItm.districtName }}</span>
    <span class="table__cell table__cell--align-left" role="cell">{{ schoolItm.city }}</span>
    <span class="table__cell table__cell--half" role="cell">{{ schoolItm.state }}</span>
</div>
